import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
    Form,
    Row,
    Col,
    Modal,
    message,
    Popconfirm,
    Spin,
    Select,
    Button,
    Icon,
    Table,
    Input,
    InputNumber,
    DatePicker,
    TimePicker,
    Radio,
    Checkbox,
    Calendar,
} from 'antd';
import { connect } from 'react-redux';
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');
import { dateConversion, timeConversion, getDateBetween, showDate } from '../../../utils';
import { getHostList,modifyHost,createHostAction,createStatusAction,addHost } from './actions';
const FormItem = Form.Item;
const RadioGroup = Radio.Group;
const CheckboxGroup = Checkbox.Group;
const { TextArea } = Input;

let dataArray = [];
let user = JSON.parse(localStorage.getItem('HippoUserInfo'));
let today = dateConversion(Date.parse(new Date()));
let listData = [];

class AddAndModify extends Component {
    constructor(props) {
        super(props); // 调用super父类构造函数改变this指向
        this.submit = this.submit.bind(this);
    }
    componentDidMount() {
    }


    // async handleInterstChange(value) {
    //   console.log('aaaa',value);
    // };
    //
    // async handleUserInfoChange(value) {
    //
    // };

    changeAddHide = () => {
        this.props.changeStatus(0);
        this.props.storeHost({});
        this.props.form.resetFields();
    };

    async submit() {
        console.log(this)
        this.props.form.validateFields(async (err, fieldsValue) => {
            if (!err) {
                try {
                    let {ip, description, ...rest} = fieldsValue;
                    let result = {
                        ip,
                        description,
                        worker: rest,
                    };
                    if (this.props.status == 1) {
                        await this.props.ModifyHost(result);
                    } else if (this.props.status == 2) {
                        await this.props.AddHost(result);
                    }
                    await this.props.form.resetFields();
                    await this.changeAddHide();
                    await this.props.GetHostList();
                } catch (err) {
                    console.log(err);
                    alert(err);
                }
            } else {
                console.log(err);
            }
        });
    };
    render() {
        const { getFieldDecorator, onPanelChange } = this.props.form;
        let { status, host = {} } = this.props;
        let { worker = {},index} = host;
        if (!host) {
            host = {};
        }
        if (!worker) {
            worker = {};
        }
        const formItemLayout = {
            labelCol: {
                xs: { span: 18 },
                sm: { span: 6 },
            },
            wrapperCol: {
                xs: { span: 18 },
                sm: { span: 14 },
            },
        };
        const options = ['NORMAL', 'CLICK', 'EV', 'NORMAL_APPOINT', 'APPOINT_CLICK', 'APPOINT_EV'];
        const partnerListOption = options.map(item => <Option value={item}>{item}</Option>);
        return (
            <div>
                <Modal
                    title={status == 1 ? '修改' : '添加'}
                    visible={status == 1 || status == 2 }
                    onCancel={() => this.changeAddHide()}
                    onOk={() => {
                        this.submit();
                    }}>
                    <Form>
                        <FormItem {...formItemLayout} label="地址">
                            {getFieldDecorator('ip', {
                                initialValue: status == 1 ? host.ip : '',
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入ip地址,例如172.0.0.1',
                                        pattern: /^\d{1,3}.\d{1,3}.\d{1,3}.\d{1,3}$/,
                                    },
                                ],
                            })(<Input placeholder="请输入ip地址"  disabled={status == 1 ? true : false} />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="描述">
                            {getFieldDecorator('description', {
                                initialValue: status == 1 ? host.description : undefined,
                            })(<Input placeholder="请填入描述信息" />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="phantomJS路径">
                            {getFieldDecorator('driverPath', {
                                initialValue: worker.driverPath || '/data/programs/hippo/lib/phantomjs',
                                rules: [
                                    {
                                        required: true,
                                        message: '请填入phantomJS路径',
                                    },
                                ],
                            })(<Input placeholder="请填入phantomJS路径" />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="机器分类">
                            {getFieldDecorator('category', {
                                initialValue: worker.category || 'NORMAL',
                                rules: [
                                    {
                                        required: true,
                                        message: '请选择机器分类',
                                    },
                                ],
                            })(
                                <Select style={{ width: '100%' }} placeholder="请选择机器分类">
                                    {partnerListOption}
                                </Select>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="机器分组ID">
                            {getFieldDecorator('groupId', {
                                initialValue: worker.groupId || '0',
                                rules: [
                                    {
                                        required: true,
                                        message: '请填入机器分组ID',
                                    },
                                ],
                            })(<Input placeholder="请填入机器分组ID" />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="server IP">
                            {getFieldDecorator('hostIp', {
                                initialValue: worker.hostIp || '10.32.0.10',
                                rules: [
                                    {
                                        required: true,
                                        message: '请填入server IP',
                                    },
                                ],
                            })(<Input placeholder="请填入server IP" />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="本机IP">
                            {getFieldDecorator('localIp', {
                                initialValue: worker.localIp,
                                rules: [
                                    {
                                        required: true,
                                        message: '请填入本机IP',
                                    },
                                ],
                            })(<Input placeholder="请填入本机IP" />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="网络">
                            {getFieldDecorator('netName', {
                                initialValue: worker.netName || 'cnc',
                                rules: [
                                    {
                                        required: true,
                                        message: '请填入网络',
                                    },
                                ],
                            })(<Input placeholder="请填入网络" />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="server端口">
                            {getFieldDecorator('port', {
                                initialValue: worker.port || '8088',
                                rules: [
                                    {
                                        required: true,
                                        message: '请填入server端口',
                                    },
                                ],
                            })(<Input placeholder="请填入server端口" />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="并发度">
                            {getFieldDecorator('taskParallel', {
                                initialValue: worker.taskParallel || '800',
                                rules: [
                                    {
                                        required: true,
                                        message: '请填入并发度',
                                    },
                                ],
                            })(<Input placeholder="请填入并发度" />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="超时时间">
                            {getFieldDecorator('waitTimeout', {
                                initialValue: worker.waitTimeout || '5000',
                                rules: [
                                    {
                                        required: true,
                                        message: '请填入超时时间',
                                    },
                                ],
                            })(<Input placeholder="请填入超时时间" />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="zookeeper路径">
                            {getFieldDecorator('zkPath', {
                                initialValue: worker.zkPath || '/hippo/workers',
                                rules: [
                                    {
                                        required: true,
                                        message: '请填入zookeeper路径',
                                    },
                                ],
                            })(<Input placeholder="请填入zookeeper路径" />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="点击并发度">
                            {getFieldDecorator('clickTaskParallel', {
                                initialValue: worker.clickTaskParallel || '45',
                                rules: [
                                    {
                                        required: true,
                                        message: '请填入点击并发度',
                                    },
                                ],
                            })(<Input placeholder="请填入点击并发度" />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="曝光并发度">
                            {getFieldDecorator('evTaskParallel', {
                                initialValue: worker.evTaskParallel || '900',
                                rules: [
                                    {
                                        required: true,
                                        message: '请填入曝光并发度',
                                    },
                                ],
                            })(<Input placeholder="请填入曝光并发度" />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="顺序">
                            {getFieldDecorator('index', {
                                initialValue: index,

                            })(<Input placeholder="请填入顺序" disabled={status == 1 ? true : false}  />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="点击队列桶位置">
                            {getFieldDecorator('clickBucketIndex', {
                                initialValue: worker.clickBucketIndex,

                            })(<InputNumber placeholder="请填入点击队列桶位置" style={{ width: '100%' }}/>)}
                        </FormItem>

                    </Form>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    status: state.hostList.Status,
    host: state.hostList.Host,
});

const mapDispatchToProps = dispatch => ({
  GetHostList: prarms => dispatch(getHostList()),
  ModifyHost: prarms => dispatch(modifyHost(prarms)),
  AddHost: prarms => dispatch(addHost(prarms)),
  storeHost: param => dispatch(createHostAction(param)),
  changeStatus: status => dispatch(createStatusAction(status))
});

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(AddAndModify));



// WEBPACK FOOTER //
// ./pages/assist/hostManage/addAndModify.js